var map = {
	"./Designer Wall Panels.jpeg": 820,
	"./Ivory Gold Premium Ceiling.jpeg": 8953,
	"./Laminated UPVC Door.jpeg": 4145,
	"./Living Room PVC Decor.jpeg": 1516,
	"./Luxery PVC Wall Panels.jpeg": 7291,
	"./Minimal Ivory Flush Door.jpeg": 3606,
	"./Modern Celling Designs.jpeg": 8690,
	"./Modern Graphite Line Door.jpeg": 3413,
	"./Premium Layered PVC Design.jpeg": 4914,
	"./Signature Wooden Strip Ceiling.jpeg": 5343,
	"./Textured Wall Treatments.jpeg": 8666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8289;